<template>
	<div class="keywordsearch">
		<div v-if="search_input">
			<div class="text_box">
				<van-field
				v-model="message"
				rows="6"
				type="textarea"
				maxlength="100"
				placeholder="请填写关键词或句子"
				show-word-limit
				:autofocus='true'
				/>
			</div>
			<div class="choose_term">
				<div style="flex: 1"></div>
				<div :class="btn_type==1?'time_btn_active time_btn':'time_btn'" @click="chioseDays(1)">7天</div>
				<div :class="btn_type==2?'time_btn_active time_btn':'time_btn'" @click="chioseDays(2)">30天</div>
				<div :class="btn_type==3?'time_btn_active time_btn':'time_btn'" @click="chioseDays(3)">自定义时间</div>
				<div class="search_btn" @click="onSearch">搜索</div>
			</div>
			<div class="time_box" v-if="btn_type==3">
				<van-field
				readonly
				clickable
				name="startTime"
				:value="start_time"
				placeholder="起始时间"
				@click="showPickerd(1)"
				/>
				至
				<van-field
				readonly
				clickable
				name="endTime"
				:value="end_time"
				placeholder="结束时间"
				@click="showPickerd(2)"
				/>
			</div>
			<van-popup v-model="showPicker" position="bottom">
				<van-datetime-picker
				v-model="currentDate"
				type="date"
				@confirm="onConfirm"
				@cancel="showPicker = false"
				:max-date="maxDate"
				/>
			</van-popup>
		</div>
		<div class="searchresult" v-else>
			<div class="search_resu">
				<div class="result_title">预警内容【{{info.key}}】搜索结果
					<img class="iskeyword" :src="img.iskeyword" v-if="is_default==1">
					<img class="addkeyword" :src="img.addkeyword" v-elif="is_default==0" @click="addKeyword()">
				</div>
				<div class="result_box">
					<van-row class="result_box_title">
						<van-col span="10">关联论坛</van-col>
						<van-col class="text-c" span="6">关联贴子数</van-col>
						<van-col class="text-c" span="4">评论数</van-col>
						<van-col class="text-c" span="4">操作</van-col>
					</van-row>
					<van-row v-for="(item,index) in info.bbs_arr" :key="'listb_' + index" :class="index % 2==0?'result_text result_text_active':'result_text'">
						<van-col style="text-decoration:underline;" span="10" @click="goBbsType(item.type)">{{item.name}}</van-col>
						<van-col class="text-c" span="6">{{item.number}}</van-col>
						<van-col class="text-c" span="4">103</van-col>
						<van-col class="text-c" span="4" @click="goBbsType(item.type)">查看</van-col>
					</van-row>
				</div>
			</div>
			<div class="search_resu">
				<div class="result_title">趋势图表</div>
				<!-- <div class="home_title_info"><van-icon name="info-o" /></div> -->
				<div class="result_box">
					<div class="result_box_title">
						<div class="result_left">新增帖子趋势</div>
						<div class="result_right">帖子{{info.bbs_chart_num}}篇</div>
					</div>
					<div class="keyword_box">
						<div id="myChart" style="width: 95%;height:240px;margin-left: 12px;margin-top: 15px;"></div>
					</div>
				</div>
				<div class="result_box">
					<div class="result_box_title">
						<div class="result_left">新增评论趋势</div>
						<div class="result_right">评论{{info.comment_chart_num}}条</div>
					</div>
					<div class="keyword_box">
						<div id="myChartcom" style="width: 95%;height:240px;margin-left: 12px;margin-top: 15px;"></div>
					</div>
				</div>
			</div>
			<div class="search_resu">
				<div class="result_title">相关帖子</div>
				<!-- <div class="home_title_info"><van-icon name="info-o" /></div> -->
				<div class="result_box" v-for="item in bbs_list" :key="'list_' + item.id" @click="goBbs(item.id)">
					<div class="result_bbstit">{{item.name}}
						<img class="result_title_bage" v-if="item.label_two.type==2" :src="img.new">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='1级'" :src="img.level1">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='2级'" :src="img.level2">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='3级'" :src="img.level3">
						<img class="result_title_bage" v-if="item.label.type==3" :src="img.hot">
						<img class="result_title_bage" v-if="item.label.type==4" :src="img.vie">
					</div>
					<div class="result_bbstime">
						<div style="flex: 1;">{{item.post_time}}</div>
						<div class="f-r">
							<span>阅读{{item.read_num}}</span>
							<span style="margin-left: 20px;">评论{{item.comment_num}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>
<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon } from 'vant';
	export default {
		data () {
			return {
				search_input:true,
				btn_type:1,
				message:'',
				text:'',
				maxDate:new Date(),
				currentDate: new Date(),
				showPicker:false,
				start_time:'',
				end_time:'',
				is_default:2,
				info:'',
				bbs_list:[],
				img:{
					hot:require('../../assets/img/hot.png'),
					new: require('../../assets/img/new.png'),
					level1: require('../../assets/img/level1.png'),
					level2: require('../../assets/img/level2.png'),
					level3: require('../../assets/img/level3.png'),
					vie:require('../../assets/img/vie.png'),
					iskeyword: require('../../assets/img/iskeyword.png'),
					addkeyword: require('../../assets/img/addkeyword.png'),
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		mounted() {
		},
		created () {
			var myDate = new Date(); //获取系统当前时间
			var date1 = new Date(myDate.getTime()).toLocaleDateString();
			var date2 = new Date(myDate.getTime() - (7 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			var date3 = new Date(myDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			this.end_time=date1.replace(/\//g,'-')
			this.severTime=date2.replace(/\//g,'-')
			this.thereTime=date3.replace(/\//g,'-')
			if(this.$route.query.token){
				this.token = this.$route.query.token
				this.$store.dispatch('param/setToken', this.$route.query.token)
			}
		},
		methods: {
			showPickerd(num){
				this.timeField=num
				this.showPicker=true

			},
			onConfirm(time) {
				
				
				var Y = time.getFullYear();
				var M = time.getMonth() + 1;
				M = M < 10 ? '0' + M : M;
				var D = time.getDate();
				D = D < 10 ? '0' + D : D;
				var H = time.getHours();
				H = H < 10 ? '0' + H : H;
				var Mi = time.getMinutes();
				Mi = Mi < 10 ? '0' + Mi : Mi;
				var S = time.getSeconds();
				S = S < 10 ? '0' + S : S;

				this.showPickertime = false;
				if(this.timeField==1){
					this.start_time=Y + '-' + M + '-' + D
					// this.times=time.getTime()+24*60*60*1000*60
					// var timesd=time.getTime()
					// if(this.end_time){
					// 	if(timesd>this.timed){
					// 		alert('请选择60日之内的自定义时间')
					// 	}else{
					// 		this.start_time=Y + '-' + M + '-' + D
					// 	}
					// }else{
					// 	this.start_time=Y + '-' + M + '-' + D
					// }
				}else{
					this.end_time=Y + '-' + M + '-' + D
					// this.timed=time.getTime()-24*60*60*1000*60
					// var timesd=time.getTime()
					// if(this.start_time){
					// 	if(timesd<this.times){
					// 		alert('请选择60日之内的自定义时间')
					// 	}else{
					// 		this.end_time=Y + '-' + M + '-' + D
					// 	}
					// }else{
					// 	this.end_time=Y + '-' + M + '-' + D
					// }
				}
				this.showPicker = false;
			},
			onSearch() {
				if(this.token){
					if(this.message==''){
						this.$toast('请填写关键词或句子')
					}else{
					// this.search_input=false
					if(this.btn_type==1){
						var start_time=this.severTime
					}else if(this.btn_type==2){
						var start_time=this.thereTime
					}else if(this.btn_type==3){
						var start_time=this.start_time
					}
					var params={
						page:1,
						key:this.message,
						start_time:start_time,
						end_time:this.end_time
					}
					// admin.getAdminsearchnew(params).then(res => {
					// 	if(res.data.state==1){
					// 		this.info=res.data.data
					// 		this.bbs_list=res.data.data.bbs_list
					// 		this.is_default=res.data.data.is_default
					// 		var bbs_chart_arr=res.data.data.bbs_chart_arr

					// 		var myChart = this.$echarts.init(document.getElementById('myChart'))
					// 		var series= [{
					// 			name: '关联帖子',
					// 			data:bbs_chart_arr.bbs_chart_info_number,
					// 			type: 'line',
					// 			smooth:true,
					// 			itemStyle: {
					// 				color: '#303231'
					// 			},
					// 		}]
					// 		myChart.setOption({
					// 			tooltip: {
					// 				trigger: 'axis'
					// 			},

					// 			xAxis: {
					// 				type: 'category',
					// 				boundaryGap: false,
					// 				data:bbs_chart_arr.bbs_chart_info_date
					// 			},
					// 			yAxis: {
					// 				type: 'value'
					// 			},
					// 			legend: {
					// 				data:['频次','关联帖子']
					// 			},
					// 			series:series
					// 		});
					// 		var comment_chart_arr=res.data.data.comment_chart_arr
					// 		var myChartcom = this.$echarts.init(document.getElementById('myChartcom'))
					// 		var series= [{
					// 			name: '关联评论',
					// 			data:comment_chart_arr.comment_chart_info_number,
					// 			type: 'line',
					// 			smooth:true,
					// 			itemStyle: {
					// 				color: '#303231'
					// 			},
					// 		}]
					// 		myChartcom.setOption({
					// 			tooltip: {
					// 				trigger: 'axis'
					// 			},

					// 			xAxis: {
					// 				type: 'category',
					// 				boundaryGap: false,
					// 				data: comment_chart_arr.comment_chart_info_date
					// 			},
					// 			yAxis: {
					// 				type: 'value'
					// 			},
					// 			legend: {
					// 				data:['频次','关联评论']
					// 			},
					// 			series:series
					// 		});
					// 		localStorage.removeItem('searchParams')
					// 	}else{
					// 	}

					// })
					localStorage.setItem('btn_type', this.btn_type)
					var item=JSON.stringify(params);
					localStorage.setItem('searchParams', item)
					setTimeout(function(){
						wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=searchresult'})
						this.message=''
					},100);
					
				}
			}else{
				wx.miniProgram.navigateTo({url:'/pages/login/login'})
			}

		},
		chioseDays(day){
			if(this.token){
				this.btn_type=day
				if(day==3){
					this.start_time=''
					this.end_time=''
				}
			}else{
				wx.miniProgram.navigateTo({url:'/pages/login/login'})
			}
		},
		addKeyword(){
			var parmas={
				content:this.info.key
			}
			admin.addKey(parmas).then(res => {
				if(res.data.state==1){
					this.is_default=2
				}else{

				}
			})

		},
		goBbs(id){
			localStorage.setItem('bbsid', id)
			wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
		},
		goBbsType(type) {
				// var key=this.info.key
				// this.$router.push({name:'KeywordWarningInfo',params:{key:key,typeid:id}});
				localStorage.setItem('bbstype', type)
				localStorage.setItem('bbskey', this.info.key)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordwarninginfo'})
			},

		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Icon.name]:Icon
		}
	}
</script>
<style lang="scss">
.keywordsearch{
	padding: 20px;
	.text_box{
		border: 1px solid #BBBBBB;
		border-radius: 4px;
		.van-cell{
			font-size: 14px;
			background-color: transparent;
		}
	}
	.choose_term{
		display: flex;
		align-items: center;
		font-size: 12px;

		.time_btn{
			border-radius:4px;
			border:1px solid #666666;
			color: #000000;
			margin: 5px;
			padding:6px 12px;
		}
		.time_btn_active{
			background-color:#BBBBBB;
		}
		.search_btn{
			color: #fff;
			border:1px solid #333333;
			background-color: #333333;
			border-radius:4px;
			margin: 5px;
			padding:6px 18px;
		}
	}
	.time_box{
		border-radius:4px;
		border:1px solid #BBBBBB;
		display: flex;
		align-items:center;
		font-size: 14px;
		margin-top: 40px;
		.time_left{
			flex: 1;
		}
		.van-field{
			margin: 0 5px;
		}
		.van-cell{
			padding:5px;
			width: 50%;
			.van-field__control{
				text-align: center;
			}
		}
		.van-button{
			height: 36px;
			line-height: 0;
		}
	}

	.searchresult{
		.result_title{
			font-size: 14px;
			margin-top: 15px;
			padding-bottom:10px;
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			.home_title_info{
				margin-left: 10px;
				font-size: 9px;
				color: #999999;
				display: flex;
				align-items: center;
			}
			.iskeyword{
				width: 80px;
				height: 20px;
				margin-left: 5px;
			}
			.addkeyword{
				width: 94px;
				height: 20px;
				margin-left: 5px;
			}
		}
		.search_resu{
			margin-top: 20px;
			.result_box{
				font-size: 12px;
				padding:15px;
				margin-top: 15px;
				border:1px solid #BBBBBB;
				border-radius:4px;
				.result_box_title{
					display: flex;
					align-items:center;
					border-bottom:1px solid #EEEEEE;
					padding:0 10px 10px 10px;
					margin-bottom: 10px;
				}
				.result_text{
					display: flex;
					align-items:center;
					padding:10px 10px;
				}
				.result_text_active{
					background-color:#F8F8F8;
				}
				.result_left{
					flex: 1;
				}
				.result_right{
					float: right;
				}
				.result_bbstit{
					color: #333333;
					font-size: 12px;
					text-decoration:underline;
					border-bottom:1px solid #EEEEEE;
					padding-bottom:10px;
				}
				.result_title_bage{
					width: 36px;
					height: 16px;
					vertical-align:middle;
					margin-left: 10px;
				}
				.result_bbstime{
					color: #999999;
					font-size: 12px;
					padding-top:10px;
					display: flex;
					align-items:center;
				}
			}
			.keyword_box{
				border: 1px solid #BBBBBB;
				border-radius: 4px;
				font-size:12px;
			}
		}
	}
}
</style>